import script from "./ProjectDelete.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectDelete.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectDelete.vue?vue&type=style&index=0&id=0dd986a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd986a9"]])

export default __exports__